/** @file Structural equality of JSON-shaped document data, for the same-value no-op checks (W2-31). */

/** True when `a` and `b` serialize to the same JSON (property order counts; undefined equals only undefined). */
export function sameJson(a: unknown, b: unknown): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}
